import React from 'react';

const defaultLocale: string = "lt";
export const LocaleContext = React.createContext(defaultLocale);